/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateActivationsControllerFindAllQueryResponse, TemplateActivationsControllerFindAllQueryParams, TemplateActivationsControllerFindAll401, TemplateActivationsControllerFindAll403 } from "../../models/checklistsController/TemplateActivationsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateActivationsControllerFindAll } from "../../clients/checklistsService/templateActivationsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateActivationsControllerFindAllQueryKey = (params: TemplateActivationsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-template-activations'
}, ...(params ? [params] : [])] as const;
export type TemplateActivationsControllerFindAllQueryKey = ReturnType<typeof templateActivationsControllerFindAllQueryKey>;
export function templateActivationsControllerFindAllQueryOptions(params?: TemplateActivationsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateActivationsControllerFindAllQueryKey(params);
  return queryOptions<TemplateActivationsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateActivationsControllerFindAll401 | TemplateActivationsControllerFindAll403>, TemplateActivationsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateActivationsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List template activations
 * {@link /api/v1/checklist-template-activations}
 */
export function useTemplateActivationsControllerFindAll<TData = TemplateActivationsControllerFindAllQueryResponse, TQueryData = TemplateActivationsControllerFindAllQueryResponse, TQueryKey extends QueryKey = TemplateActivationsControllerFindAllQueryKey>(params?: TemplateActivationsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateActivationsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateActivationsControllerFindAll401 | TemplateActivationsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateActivationsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...templateActivationsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateActivationsControllerFindAll401 | TemplateActivationsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}